import { useStaticElements } from "../Utils/hooks"
import { SemiStaticMeshElement, StaticMeshElement } from "../Components/BakedMeshComponents"
import { masterTexturePath } from "../../../ApartmentFinderConfig/general"
// import { isIOS } from "../Utils/Helpers"
let isIOS = false

export function StaticGeometry({ geometryID }) {
  const pathToGLTF = `staticGeometry/${geometryID}/${geometryID}`

  const elements = useStaticElements({ pathToGLTF })

  const elementsMeshArr = Object.values(elements.meshs)
  return elementsMeshArr.map((mesh, i) => (
    <StaticMeshElement
      mesh={mesh}
      key={i}
      texturePath={`${masterTexturePath}${elements.textureName[i]}_d${
        isIOS ? ".compressed" : ""
      }.jpg`}
      id={i}
      objectID={elements.objectID[i]}
      materialType={elements.materialType[i]}
    />
  ))
}
export function SemiStaticGeometry({ geometryID }) {
  const pathToGLTF = `semiStaticGeometry/${geometryID}/${geometryID}`

  const elements = useStaticElements({ pathToGLTF })

  const elementsMeshArr = Object.values(elements.meshs)

  return elementsMeshArr.map((mesh, i) => (
    <SemiStaticMeshElement
      mesh={mesh}
      key={i}
      texturePath={`${masterTexturePath}${elements.textureName[i]}_d${
        isIOS ? ".compressed" : ""
      }.jpg`}
      // blockID={elements.blockID[i]}
      id={i}
      objectID={elements.objectID[i]}
      materialType={elements.materialType[i]}
    />
  ))
}

export default StaticGeometry
